module.exports = __webpack_public_path__ + "static/Roboto-Regular-5f42a5fd22c38a40bc0d552c635230a9.woff";